import React from 'react'
import styles from './styles.module.scss'
import quotationMarks from 'assets/img/comillas.png'

const  ReviewItem = ({name, review , title, date}) => (
    <div className={styles.container}>
        <div className={styles.content}>
            <div className ={styles['image-container']}>
                <img src = {quotationMarks} className={styles.image}/>
            </div>
            <article className={styles['review-container']}>
                <span className={styles.review}>{review}</span>
            </article>
            <article className={styles['user-container']}>
                <span className={styles.user}>{name[0]}</span>
                <article className={styles['about-container']}>
                    <span className={styles.name}>{name}</span>
                    <span className={styles.title}>{title} {date}</span>
                </article>
            </article>
        </div>
    </div>
)

export default ReviewItem
